import ApiService from "./apiservice";

export const FunctionalityService = {
    getPersonDayWorksTotal(payload) {
        return ApiService.get("GetPersonDayWorksTotal", payload);
    },
    GetPersonDayWorks(payload) {
        return ApiService.get("Daywork/GetPersonDayWorksDetail", payload);
    },
    GetPersonDayWorksDetail(payload) {
        return ApiService.get("Daywork/GetPersonDayWorksDetail2", payload);
    },
    /**
     * PeriodWork
     */
    GetPersonPeriodWork(payload) {
        return ApiService.get("periodwork/GetPersonPeriodWork", payload);
    },
    GetEosPeriodicYearsList() {
        return ApiService.get("periodwork/GetEosYearsList");
    },
    GetEosPeriodList(payload) {
        return ApiService.get("periodwork/GetEosPeriodList", payload);
    },
    GetPersonPeriodWorkDetail(payload) {
        return ApiService.get("PeriodWork/GetPersonPeriodWorkDetail", payload);
    },
    /**
     * MonthlyWork
     */
    GetEosMonthlyYearsList() {
        return ApiService.get("MonthlyWork/GetEosYearsList");
    },
    GetEosMonthList(payload) {
        return ApiService.get("MonthlyWork/GetEosMonthList", payload);
    },
    GetPersonMonthWork(payload) {
        return ApiService.get("MonthlyWork/GetPersonMonthWork", payload);
    },
    GetPersonelMonthWork(payload) {
        return ApiService.get("MonthlyWork/GetPersonelMonthWork", payload);
    },

};